/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from 'react'
import {initialQueryState, KTSVG, QUERIES} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from '../core/QueryRequestProvider'
import { useIntl } from 'react-intl'
import { getAll } from '../../../../services/common_requests'
import { useQuery } from 'react-query'

const ReservationsListSearchComponent = () => {
  const {updateState} = useQueryRequest()
  const [statusFilter, setStatusFilter] = useState<string>('') 
  const [paymentMethodFilter, setPaymentMethodFilter] = useState<string>('') 
  
  // Separate creation date filters and check-in date filters
  const [startDate, setStartDate] = useState<string>('') // Creation date start
  const [endDate, setEndDate] = useState<string>('') // Creation date end
  const [checkInDateStart, setCheckInDateStart] = useState<string>('') // Check-in date start
  const [checkInDateEnd, setCheckInDateEnd] = useState<string>('') // Check-in date end

  // Fetch statuses from the API
  const {
    data: statusesResponse,
    isLoading: isStatusLoading,
    error: statusError,
  } = useQuery(
    `${QUERIES.STATUSES_LIST}-statuses`,
    () => getAll('', '/status'),
    {
      cacheTime: 60 * 60 * 1000, 
      staleTime: 30 * 60 * 1000, 
      onError: (err) => {
        console.error('Failed to fetch statuses:', err);
      },
    }
  );

  // Fetch payment methods from the API
  const {
    data: paymentMethodsResponse,
    isLoading: isPaymentMethodLoading,
    error: paymentMethodError,
  } = useQuery(
    `${QUERIES.PAYMENT_METHODS_LIST}-paymentMethods`,
    () => getAll('', '/payment-methods'),
    {
      cacheTime: 60 * 60 * 1000, 
      staleTime: 30 * 60 * 1000, 
      onError: (err) => {
        console.error('Failed to fetch payment methods:', err);
      },
    }
  );

  const statuses = statusesResponse?.data || [];
  const paymentMethods = paymentMethodsResponse?.data || [];

  // Effect for API call
  useEffect(() => {
    const queryParams: any = {
      ...initialQueryState
    }

    // Add status filter if selected
    if (statusFilter) {
      queryParams.statusIds = statusFilter
    }

    // Add payment method filter if selected
    if (paymentMethodFilter) {
      queryParams.paymentMethod = paymentMethodFilter
    }

    // Add creation date filters if set
    if (startDate) {
      queryParams.startDate = startDate
    }
    if (endDate) {
      queryParams.endDate = endDate
    }

    // Add check-in date filters if set
    if (checkInDateStart) {
      queryParams.checkInDateStart = checkInDateStart
    }
    if (checkInDateEnd) {
      queryParams.checkInDateEnd = checkInDateEnd
    }

    updateState(queryParams)
  }, [statusFilter, paymentMethodFilter, startDate, endDate, checkInDateStart, checkInDateEnd])

  const intl = useIntl();

  const clearFilters = () => {
    setStatusFilter('')
    setPaymentMethodFilter('')
    setStartDate('')
    setEndDate('')
    setCheckInDateStart('')
    setCheckInDateEnd('')
    
    // Immediately trigger API call with empty filters
    updateState({
      ...initialQueryState
    })
  }

  // Check if any filter is active
  const hasActiveFilters = statusFilter || paymentMethodFilter || startDate || endDate || checkInDateStart || checkInDateEnd

  return (
    <div className='card-title w-100'>
      {/* Filters */}
      <div className='card border border-gray-300 mb-5'>
        <div className='card-body p-6'>
          {hasActiveFilters && (
            <div className='d-flex justify-content-end mb-4'>
              <button
                type='button'
                className='btn btn-light-danger btn-sm'
                onClick={clearFilters}
                title='Effacer tous les filtres'
              >
                <KTSVG path='/media/icons/duotune/general/gen034.svg' className='svg-icon-3 me-1' />
                Effacer les filtres
              </button>
            </div>
          )}
          
          <div className='row g-5'>
            {/* Status Filter */}
            <div className='col-lg-3 col-md-6'>
              <label className='form-label fw-semibold text-gray-800 fs-6 mb-3'>
                <KTSVG path='/media/icons/duotune/general/gen043.svg' className='svg-icon-3 me-2' />
                {intl.formatMessage({ id: 'COMMON.STATUSES' })}
              </label>
              <select
                className='form-select form-select-solid fs-6'
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                disabled={isStatusLoading}
              >
                <option value="">{intl.formatMessage({ id: 'COMMON.ALL_STATUSES' })}</option>
                {statuses?.map((status: any) => (
                  <option key={status._id} value={status._id}>
                    {status.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Payment Method Filter */}
            <div className='col-lg-3 col-md-6'>
              <label className='form-label fw-semibold text-gray-800 fs-6 mb-3'>
                <KTSVG path='/media/icons/duotune/finance/fin002.svg' className='svg-icon-3 me-2' />
                {intl.formatMessage({ id: 'COMMON.PAYMENT_METHODS' })}
              </label>
              <select
                className='form-select form-select-solid fs-6'
                value={paymentMethodFilter}
                onChange={(e) => setPaymentMethodFilter(e.target.value)}
                disabled={isPaymentMethodLoading}
              >
                <option value="">{intl.formatMessage({ id: 'COMMON.ALL_PAYMENT_METHODS' })}</option>
                {paymentMethods?.map((paymentMethod: any) => (
                  <option key={paymentMethod._id} value={paymentMethod._id}>
                    {paymentMethod.description || paymentMethod.code}
                  </option>
                ))}
              </select>
            </div>

            {/* Creation Date From */}
            <div className='col-lg-3 col-md-6'>
              <label className='form-label fw-semibold text-gray-800 fs-6 mb-3'>
                <KTSVG path='/media/icons/duotune/general/gen014.svg' className='svg-icon-3 me-2' />
                Dates de création
              </label>
              <div className='d-flex align-items-center'>
                <span className='text-gray-600 fs-6 me-2'>Du:</span>
                <input
                  type='date'
                  className='form-control form-control-solid fs-6'
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
            </div>

            {/* Creation Date To */}
            <div className='col-lg-3 col-md-6'>
              <label className='form-label fw-semibold text-gray-800 fs-6 mb-3 invisible'>
                Dates de création
              </label>
              <div className='d-flex align-items-center'>
                <span className='text-gray-600 fs-6 me-2'>Au:</span>
                <input
                  type='date'
                  className='form-control form-control-solid fs-6'
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>

            {/* Check-in Date From */}
            <div className='col-lg-3 col-md-6'>
              <label className='form-label fw-semibold text-gray-800 fs-6 mb-3'>
                <KTSVG path='/media/icons/duotune/general/gen020.svg' className='svg-icon-3 me-2' />
                Dates de séjour
              </label>
              <div className='d-flex align-items-center'>
                <span className='text-gray-600 fs-6 me-2'>Du:</span>
                <input
                  type='date'
                  className='form-control form-control-solid fs-6'
                  value={checkInDateStart}
                  onChange={(e) => setCheckInDateStart(e.target.value)}
                />
              </div>
            </div>

            {/* Check-in Date To */}
            <div className='col-lg-3 col-md-6'>
              <label className='form-label fw-semibold text-gray-800 fs-6 mb-3 invisible'>
                Dates de séjour
              </label>
              <div className='d-flex align-items-center'>
                <span className='text-gray-600 fs-6 me-2'>Au:</span>
                <input
                  type='date'
                  className='form-control form-control-solid fs-6'
                  value={checkInDateEnd}
                  onChange={(e) => setCheckInDateEnd(e.target.value)}
                />
              </div>
            </div>

            {/* Empty columns for alignment */}
            <div className='col-lg-6'></div>
          </div>
        </div>
      </div>

      {/* Active Filters Summary */}
      {hasActiveFilters && (
        <div className='alert alert-primary d-flex align-items-center p-5 mb-5'>
          <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2 me-4' />
          <div className='d-flex flex-wrap align-items-center gap-3 flex-grow-1'>
            <span className='fw-bold fs-6 text-primary'>Filtres actifs:</span>
            {statusFilter && (
              <span className='badge badge-light-success fs-7 py-2 px-3'>
                {statuses.find((s: any) => s._id === statusFilter)?.name}
              </span>
            )}
            {paymentMethodFilter && (
              <span className='badge badge-light-warning fs-7 py-2 px-3'>
                {paymentMethods.find((p: any) => p._id === paymentMethodFilter)?.description || paymentMethods.find((p: any) => p._id === paymentMethodFilter)?.code}
              </span>
            )}
            {(startDate || endDate) && (
              <span className='badge badge-light-dark fs-7 py-2 px-3'>
                Création: {startDate || '...'} → {endDate || '...'}
              </span>
            )}
            {(checkInDateStart || checkInDateEnd) && (
              <span className='badge badge-light-dark fs-7 py-2 px-3'>
                Séjour: {checkInDateStart || '...'} → {checkInDateEnd || '...'}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export {ReservationsListSearchComponent}
